


























































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import Enum from "@/components/Global/enumerate"; //全局常量
import { WXText } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: {}
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Prop()
  private AddaccountForm: WXText | any; //定义数据在WXtext里
  private GetAppData: any = []; //取应用号信息
  private switchType = false;

  private switchState = true;
  @Provide()
  //验证数据
  data() {
    //验证必填字段
    return {
      rules: {
        Keyword: [
          { required: true, message: "请输入关键词", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        Type: [{ required: true, message: "请选择类型", trigger: "change" }],
        State: [{ required: true, message: "请选择状态", trigger: "change" }],
        Contents: [
          { required: true, message: "请输入内容或简介", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  }
  //取消方法
  cancle() {
    this.$emit("backtable");
  }

  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
     var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj:any) => {
      that.GetAppData.Aid=obj.Aid;      
    });
    if (this.AddaccountForm.Type == 0) {
      this.switchType = true;
    } else {
      this.switchType = false;
    }
    if (this.AddaccountForm.State == 1) {
      this.switchState = true;
    } else {
      this.switchState = false;
    }
    console.log(this.AddaccountForm);
  }
  //保存数据
  async SavaTextData() {
    var _this = this;
    (_this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        let AppAccount = this.GetAppData;

        if (AppAccount) {
          this.AddaccountForm.ApplicationId = AppAccount.Aid;
          this.AddaccountForm.TenantId = AppAccount.TenantID;
          if (this.switchType) {
            this.AddaccountForm.Type = 0;
          } else {
            this.AddaccountForm.Type = 1;
          }
          if (this.switchState) {
            this.AddaccountForm.State = 1;
          } else {
            this.AddaccountForm.State = 0;
          }
          //保存的数据 传参
          if (this.AddaccountForm.TextId) {
            this.AddaccountForm.ActionName = "UPDATE"; //修改方法
          } else {
            this.AddaccountForm.ActionName = "CREATE"; //新增方法
          }

          let params: any = {
            Input: [
              {
                Name: "AppReplyTextDTO",
                value: this.AddaccountForm
              }
            ]
          };
          var res: any = await httpApi.SaveWxText(params);
          if (res.ErrorCode == 0) {
            this.$message.success("保存成功!");
            //保存成功后传个刷新方法过去
            _this.$emit("refresh");
          } else {
            this.$message.error("保存失败：" + res.ErrorMessage);
          }
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
}
